import ConfirmDialog from '../../../components/ConfirmDialog';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface DisableAssetConfirmDialogProps {
  pending: { category: number; name: string } | null;
  step: 1 | 2;
  affectedCount: number;
  affectedDetails: Array<{ episodeIndex: number; shotIndex: number }>;
  loading: boolean;
  t: Translate;
  onCancel: () => void;
  onConfirm: () => void;
}

function DisableAssetStepOneMessage({
  affectedCount,
  affectedDetails,
  t,
}: Pick<DisableAssetConfirmDialogProps, 'affectedCount' | 'affectedDetails' | 't'>) {
  const grouped: Record<number, number[]> = {};
  for (const detail of affectedDetails) {
    if (!grouped[detail.episodeIndex]) grouped[detail.episodeIndex] = [];
    grouped[detail.episodeIndex].push(detail.shotIndex);
  }

  return (
    <div>
      <p style={{ margin: '0 0 0.5rem' }}>{t('confirmDialogs.disableAsset.step1Prefix', { count: affectedCount })}</p>
      <div style={{ maxHeight: '200px', overflowY: 'auto', background: 'var(--bg, #f9fafb)', borderRadius: '6px', padding: '0.4rem 0.6rem', fontSize: '0.82rem', lineHeight: 1.8 }}>
        {Object.keys(grouped).map(Number).sort((a, b) => a - b).map((episodeIndex) => (
          <div key={episodeIndex}>
            <span style={{ fontWeight: 600 }}>{t('confirmDialogs.disableAsset.step1Episode', { index: episodeIndex })}</span>
            <span style={{ color: 'var(--text-3, #999)', marginLeft: '0.4rem' }}>
              {t('confirmDialogs.disableAsset.step1Shot', { shots: grouped[episodeIndex].sort((a, b) => a - b).map(shot => `#${shot}`).join(', ') })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function DisableAssetConfirmDialog({
  pending,
  step,
  affectedCount,
  affectedDetails,
  loading,
  t,
  onCancel,
  onConfirm,
}: DisableAssetConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={!!pending}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={t('confirmDialogs.disableAsset.title')}
      message={
        step === 1
          ? <DisableAssetStepOneMessage affectedCount={affectedCount} affectedDetails={affectedDetails} t={t} />
          : t('confirmDialogs.disableAsset.step2Message', { name: pending?.name || '' })
      }
      confirmText={step === 1 ? t('confirmDialogs.disableAsset.step1Confirm') : t('confirmDialogs.disableAsset.step2Confirm')}
      confirmDanger
      loading={loading}
    />
  );
}
